import apiClient from "./client";

export const getAdminBlogPosts = async () => {
  const response = await apiClient.get("/blog/admin");
  return response.data;
};

export const createAdminBlogPost = async (payload) => {
  const response = await apiClient.post("/blog/admin", payload);
  return response.data;
};

export const updateAdminBlogPost = async ({ id, payload }) => {
  const response = await apiClient.put(`/blog/admin/${id}`, payload);
  return response.data;
};

export const deleteAdminBlogPost = async ({ id }) => {
  await apiClient.delete(`/blog/admin/${id}`);
};

export const uploadAdminBlogImage = async ({ id, language, file }) => {
  const formData = new FormData();
  formData.append("file", file);
  const response = await apiClient.post(`/blog/admin/${id}/image`, formData, {
    params: { language },
    headers: { "Content-Type": "multipart/form-data" },
  });
  return response.data;
};

export const deleteAdminBlogImage = async ({ id, language }) => {
  const response = await apiClient.delete(`/blog/admin/${id}/image`, {
    params: { language },
  });
  return response.data;
};
